// extracted by mini-css-extract-plugin
export var activityContainer = "_fh-0";
export var typingIndicatorContainer = "_fh-1";
export var typingIndicatorDot = "_fh-2";
export var wave = "_fh-3";